import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

function ErrorModal({ showErrorModal, handleCloseErrorModal, errorMessage }) {
  const { t } = useTranslation();
  return (
    <Modal
      backdrop="static"
      size="lg"
      show={showErrorModal}
      onHide={handleCloseErrorModal}
      centered
    >
      <Modal.Header closeVariant="white" closeButton>
        <Modal.Title>{t("error")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-danger">{errorMessage}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseErrorModal}>
          {t("button_close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
ErrorModal.propTypes = {
  showErrorModal: PropTypes.bool.isRequired,
  handleCloseErrorModal: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
};
export default ErrorModal;
